'use strict';

var lingojsCore = require('@bookingcom/lingojs-core');

/* This file is auto-generated and should not be edited (see `forms-generate` script in package.json) */
var fakeIndex = 'fakeIndex';
/**
 *
 * Locale | Example output
 * --- | ---
 * `en-gb` | 5 Dec, 13:45
 * `en-us` | Dec 5, 1:45 PM
 * `es` | 5 dic, 13:45
 *
 * ---
 *
 * Full CDF list: https://office.booking.com/admintranslate/site/translate.html?lang=all&aid=1&tag=/date_format/1/day_short_month_time
 */
var form = 'day_short_month_time';
lingojsCore.registerDynamicTags(lingojsCore.t('date_format', fakeIndex, 'day_short_month_time'));

module.exports = form;
//# sourceMappingURL=index.js.map
